// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__AfWU2","valuesOuterContainer":"styles_valuesOuterContainer__p2fqp","valueContainer":"styles_valueContainer__9gBya","value":"styles_value__XgQC3"};